module.exports = __webpack_public_path__ + "static/img/news3ab.54957c21.jpg";